export default "__VITE_ASSET__Brd$YCJb__"